import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormDialogModeEnum } from 'src/app/enums/form-dialog-mode.enum';
import { SkillFormDialogData } from 'src/app/models/skill-form-dialog-data.interface';
import { SkillBody } from 'src/app/models/skill.model';
import { ApiService } from 'src/app/services';

@Component({
  selector: 'app-skill-form-dialog',
  templateUrl: './skill-form-dialog.component.html',
  styleUrl: './skill-form-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatFormFieldModule, MatInputModule],
})
export class SkillFormDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<SkillFormDialogComponent, boolean>);
  private readonly api_service = inject(ApiService);
  private readonly form_builder = inject(FormBuilder);

  readonly data = inject<SkillFormDialogData>(MAT_DIALOG_DATA);

  readonly loading = signal(false);
  readonly is_edit_mode = this.data.mode === FormDialogModeEnum.Edit;

  readonly form = this.form_builder.group({
    name: [this.data.skill?.name ?? '', [Validators.required, Validators.maxLength(255)]],
  });

  save(): void {
    if (this.loading() || this.form.invalid) {
      return;
    }

    this.loading.set(true);

    const raw = this.form.getRawValue();
    const body: SkillBody = {
      name: raw.name ?? '',
    };

    const request$ =
      this.is_edit_mode && this.data.skill ? this.api_service.updateSkill(this.data.skill.id, body) : this.api_service.createSkill(body);

    request$.subscribe({
      next: (): void => {
        this.dialog_ref.close(true);
      },
      error: (): void => {
        this.loading.set(false);
      },
    });
  }
}
